import { queryOptions } from "@tanstack/react-query";
import TicketService from "../ticket/ticket.service";
import AgentService from "./agent.service";
import { queryClient } from "@/lib/queryClient";

export const agentFeatureKeys = {
  all: ['agent-features'] as const,
  allByAgentId: (id: number) => [...agentFeatureKeys.all, id] as const,
}

export const createAgentOptionsQuery = (customerId: number | undefined, ticketId?: number) => queryOptions<any>({
  queryKey: ['agents-by-customer', customerId, ticketId],
  queryFn: async () => {
    const ticketService = TicketService();
    if (!customerId) return new Promise((resolve) => resolve(null));
    return new Promise(async (resolve) => {
      await ticketService
        .getAgentsByCustomer({
          customerId: customerId,
          ticketId: ticketId,
        })
        .then((res) => {
          resolve(res.data);
        });
    });
  },
  ...queryClient.defaultQueryOptions,
  enabled: !!customerId,
});

export const createWorkflowAgentByCustomerQuery = ({ customerId }: { customerId?: number }) => queryOptions<any>({
  queryKey: ['workflow-agents-by-customer', customerId],
  queryFn: async () => {
    const ticketService = TicketService();
    if (!customerId) return new Promise((resolve) => resolve(null));
    return new Promise(async (resolve) => {
      await ticketService
        .getWorkflowAgentsByCustomer({
          customerId: customerId,
        }).then((res) => {
          resolve(res.data);
        });
    });
  },
  ...queryClient.defaultQueryOptions,
  enabled: !!customerId,
});

export const createAgentFeaturesByIdQuery = ({ AgentId }: { AgentId: number }) => queryOptions<any>({
  queryKey: agentFeatureKeys.allByAgentId(AgentId),
  queryFn: async () => {
    const agentService = AgentService();
    return new Promise(async (resolve) => {
      await agentService.getAgentFeaturesById({ AgentId })
        .then((res) => {
          resolve(res.data);
        });
    });
  },
  ...queryClient.defaultQueryOptions,
  enabled: !!AgentId,
});
